<template>
    <div class="fzg-fa-mobile">
      <div class="fzg-banner">
        <fzg-menu/>
        <img class="m-banner" src="../../assets/img2/mobile/fa/banner.jpg" alt="">
        <img class="m-intro" src="../../assets/img2/mobile/fa/fa_intro.jpg" alt="">
        <img class="sologan" src="../../assets/img2/mobile/fa/sologan.png" alt="">
      </div>


      <!-- 关注领域 -->
      <div class="fzg-fa-case-list">
        <img class="case-title" src="../../assets/img2/pc/fa/fa_title_industry.png" alt="">

        <div class="case-category">
          <div v-for="(cat,index) in all_industry_data_list"
            class="cat-item"
            :class="{'cat-item-active': current_industry_list.id == cat.id}"
            @click="onClickChangeActiveIndustry(index)"
            >{{cat.name}}</div>
        </div>

        <ul class="case-wrap">
          <li class="case-item" v-for="item in current_industry_list.case_list">
            <div class="cover">
              <div class="cover-title"> {{ item.name }} </div>
              <div class="cover-intro"> {{ item.brief }} </div>
              <div class="cover-round"> {{ item.round }} </div>
              <div class="cover-content">
                <p>{{ item.vc }}</p>
              </div>
            </div>
            <!-- <img class="logo" src="../../assets/img2/pc/chuangfu/logo10.png" alt=""> -->
            <img class="logo" :src="item.logo">
          </li>

          <li v-if="false" class="case-item" v-for="item in 10">
            <div class="cover">
              <div class="cover-title"> 保碧新能源 </div>
              <div class="cover-intro"> 保利资本和碧桂园创投联合孵化的综合能源管理服务商 </div>
              <div class="cover-round"> 天使轮 </div>
              <div class="cover-content">
                华美国际集团<br>
                蔚来资本<br>
                钟鼎资本<br>
                星航资本<br>
                凡卓资本<br>
                上海易连<br>
                保利资本<br>
                碧桂园创投<br>
                多家光伏产业链头部上市公司
                </div>
            </div>
            <img class="logo" src="../../assets/img2/pc/chuangfu/logo10.png" alt="">
          </li>
        </ul>
      </div>


      <div class="fzg-industry-research">
        <img class="industry-title" src="../../assets/img2/mobile/fa/fa_title_research.png" alt="">
        <div class="fzg-industry-wrap">
          <div class="industry-left">
            <a :href="first_industry_research.link" target="_blank">
              <img src="../../assets/img2/pc/fa/fa-research-bg-1.jpg" alt="">
              <div class="l-title"> {{first_industry_research.title }}</div>
            </a>
          </div>
          <div class="industry-right">
            <a class="right-item" target="_blank" href="https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzA3OTMxMDUzOQ==&action=getalbum&album_id=2461518903014227974&scene=173&from_msgid=2653828008&from_itemidx=1&count=3&nolastread=1#wechat_redirect">
              <img src="../../assets/img2/pc/fa/fa-research-bg-2.png" alt="">
              <div class="r-item-title">产业研究</div>
            </a>
            <a class="right-item" target="_blank" href="https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzA3OTMxMDUzOQ==&action=getalbum&album_id=1332425999589670913&scene=126#wechat_redirect">
              <img src="../../assets/img2/pc/fa/fa-research-bg-3.png" alt="">
              <div class="r-item-title">&nbsp;&nbsp;行业研究</div>
            </a>
            <a class="right-item" target="_blank" href="https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzA3OTMxMDUzOQ==&action=getalbum&album_id=2646833031260979201&scene=126#wechat_redirect">
              <img src="../../assets/img2/pc/fa/fa-research-bg-4.png" alt="">
              <div class="r-item-title">区域经济研究</div>
            </a>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

import util from '../../assets/js/util'
import FzgMenu from '../common/FzgMenuMobile.vue'

export default{
    components:{
      FzgMenu
    },
    props:[''],
    data(){
      return {
        activeCompany: 1,
        all_industry_data_list: [],
        current_industry_list: [],
        first_industry_research:  {},
      }
    },
    methods:{


     getCaseList() {
        var self = this
        util.resource({
            url: '/api/fzg/focused_industry_case_list/',
            method: 'get',
            success (res) {
              if (res.code == 200) {
                self.all_industry_data_list = res.data.list
                if (self.all_industry_data_list.length > 0) {
                  // self.current_industry_list = self.all_industry_data_list[0]

                  res.data.list.forEach(item => {
                    self.current_industry_list.id = -1
                    self.current_industry_list.name = ''
                    self.current_industry_list.case_list = [].concat(self.current_industry_list.case_list || []).concat(item.case_list)
                  });
                  console.log("---------------------xxxxx---------------------")
                  console.log(self.current_industry_list)
                }
              }
            }
        })
      },
      onClickChangeActiveIndustry (index) {
        this.current_industry_list = this.all_industry_data_list[index]
      },
     getIndustryResearch() {
        var self = this
        util.resource({
            url: '/api/fzg/industry_research/',
            method: 'get',
            success (res) {
              if (res.code == 200) {
                if (res.data.list.length > 0) {
                  self.first_industry_research = res.data.list[0]

                }
                // flat data in data.list


              }
            }
        })
      },
    },
    mounted(){
      this.getCaseList()
      this.getIndustryResearch()
    },
    watch: {

    },
}
</script>

<style lang="scss">
.fzg-fa-mobile {
  .fzg-banner {
    // border: 1px solid red;
    // background-color: #8799b1;
    position: relative;
    .m-banner {
      width: 100%;
    }
    .m-intro {
      width: 100%;
    }
    .sologan {
      // border: 1px solid #ccc;
      width: 380px;
      position: absolute;
      top: 13%;
      bottom: 0;
      left: 50%;
      right: 0;
      margin-left: -190px;
    }
  }

  .fzg-fa-case-list {
    // border: 1px solid green;
    background: #f6f9ff;
    padding-top: 40px;
    padding-bottom: 80px;
    position: relative;
    .case-title {
      // border: 1px solid red;
      width: 90px;
      display: block;
      margin: 0 auto;
    }
    .case-category {
      // border: 1px solid red;
      padding: 0px 20px;
      margin: 40px auto 0;
      overflow: hidden;
      text-align: center;
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      .cat-item {
        display: inline-block;
        border: solid 1px #bfbfbf;
        border-radius: 20px;
        width: 45%;
        text-align: center;
        padding: 5px 10px;
        vertical-align: baseline;
        background: white;
        position: relative;
        margin-bottom: 20px;
        font-size: 13px;
        color: #444444;
      }

      .cat-item-active {
        border: 1px solid #c28e4f;
        background: #c28e4f;
        color: white;
        position: relative;
      }
    }
    .case-wrap {
      display: flex;
      flex-wrap: wrap;
      margin: 20px auto 20px;
      padding-left: 3px;
      // justify-content: space-between;
      // border: 1px solid red;
      // width: 1000px;
      // border-spacing: 4px;
      border-collapse: collapse;
      .case-item {
        border: 1px solid #ededed;
        list-style-type: none;
        text-align: center;
        height: 120px;
        width: 33.3%;
        margin-left: -1px;
        position: relative;
        .logo {
          margin-top: 30px;
          // border: 1px solid #ccc;
          height: 60px;
        }
        .name {
          // border: 1px solid #ccc;
          margin-top: 10px;
          font-size: 16px;
          color: #444444;
        }
        .cover {
          visibility: hidden;
          opacity: 0;
          position: absolute;
          transition: visibility 0s, opacity 0.36s linear;
          border-radius: 2px;
          text-align: left;
          // height: 100%;
          .cover-title {
            // border: 1px solid #ccc;
            font-size: 16px;
            font-weight: bold;
            padding: 15px;
            color: white;
          }
          .cover-intro {
            // border: 1px solid #ccc;
            font-size: 13px;
            line-height: 1.5;
            padding: 0px 15px;
            color: white;
          }
          .cover-round {
            font-size: 13px;
            margin: 20px 15px 0;
            padding: 20px 0;
            color: white;
            border-top: 1px solid white;
            border-bottom: 1px solid white;
          }
          .cover-content {
            // border: 1px solid #ccc;
            font-size: 12px;
            line-height: 1.7;
            padding: 15px;
            color: white;
            white-space: pre-wrap;
          }
        }

        &:hover {
          cursor: pointer;
          .cover {
            position: absolute;
            visibility: visible;
            width: 100%;
            background-color: #ad2027;
	          opacity: 0.87;
            // height: 100%;
            // display: flex;
            // align-items: center;
            z-index: 100;
          }
        }
      }
      .bus-item:nth-child(n + 6) {
        margin-top: -2px;
      }
    }
  }

  .fzg-industry-research {
    // border: 1px solid #ccc;
    // height: 800px;
    margin: 40px 30px;
    position: relative;
    .industry-title {
      width: 135px;
      margin: 0 auto;
      display: block;
    }
    .fzg-industry-wrap {
      // border: 1px solid #ccc;
      text-align: left;
      color: #575758;
      font-size: 16px;
      margin-top: 40px;
      .industry-left {
        // border: 1px solid red;
        display: block;
        background: #ededed;
        width: 100%;
        height: auto;
        margin-right: 5px;
        overflow: hidden;
        position: relative;
        img {
          width: 100%;
          height: auto;
        }
        .l-title {
          font-size: 14px;
          font-weight: bold;
          padding: 15px 10px;
          color: white;
          position: absolute;
          background: #c5020c;
          width: 100%;
          // border: 1px solid red;
          left: 0;
          bottom: 0;
          text-align: left;
        }
      }
      .industry-right {
        // border: 1px solid red;
        vertical-align: top;
        position: relative;
        display: flex;
        justify-content: space-between;
        margin-top: 2px;
        .right-item {
          width: 33%;
          height: auto;
          position: relative;
          display: inline-block;
          img {
            width: 100%;
            height: auto;
            overflow: hidden;
          }
          .r-item-title {
            font-size: 12px;
            font-weight: bold;
            color: white;
            position: absolute;
            top: 35%;
            // border: 1px solid red;
            right: 0;
            left: 0;
            text-align: center;
          }
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// FzgFaMobile.vue?70e2925c